module.exports = __webpack_public_path__ + "static/media/help-surroundplayer.cb922157.jpg";